'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
const MapProps = mapProps => Component => {
  return props => {
    return /*#__PURE__*/_jsx(Component, Object.assign({}, mapProps(props)));
  };
};
export default MapProps;